<template >

	<v-autocomplete class=""
		ref="autocomplete"
		:label="dynamicLabel"
		:loading="loading"
		:items="items"
		:dark="dark"
		:search-input.sync="search"
		no-filter
		@change="returnEmployee"
		clearable
		autofocus
		:flat="flat"
		:light="light"
		hide-no-data
		hide-details
		v-model="select"
		:solo-inverted="soloinverted"
		:outline="outline"
		solo
		return-object
		:single-line="singleline"
		style="overflow:hidden;"
		@click="dynamicLabel='Search by Name, employee ID,  or netID'"
	>
		<template slot="item" slot-scope="{ item, tile }">
	        <v-list-tile-content style="height: 70px !important;">
	        	<v-list-tile-title > 	{{item.name}} ({{item.netid}}) ({{item.employeeID}}) </v-list-tile-title>
	        	<v-list-tile-sub-title v-if="item.titleHighest"  v-text="item.titleHighest"></v-list-tile-sub-title>
	        </v-list-tile-content>
	    </template>
	    <template slot="selection" slot-scope="{ item, tile }">
	        <v-list-tile-content style="height: 70px !important;">
	        	<v-list-tile-title > 	{{item.name}}  </v-list-tile-title>
	        	<v-list-tile-sub-title v-if="item.titleHighest">{{item.titleHighest.substr(0, 60)}}</v-list-tile-sub-title>
	        </v-list-tile-content>
	    </template>
	</v-autocomplete>

</template>

<script>
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'
import _ from 'lodash'

export default {
	data: () => ({
		loading: false,
		items: [],
		search: null,
		select: null,
		dynamicLabel: null,
	}),

	created: function () {
		this.dynamicLabel = this.label
	},

	//props: ['singleline', 'soloinverted', 'label', 'flat', 'solo'],
	props: {
    	singleline: Boolean,
    	soloinverted: Boolean,
    	solo: Boolean,
    	dark: Boolean,
    	light: Boolean,
    	outline: Boolean,
    	chips: Boolean,
    	flat: { type: Boolean, default: true },
  		label: { type: String, default: 'Search by Name, employee ID,  or netID'},
  		changeHandler: Function,
    },

	watch: {
		search (val) { val && val !== this.select && val.length > 3 && this.querySelections(val) }
	},

	methods: {
		returnEmployee: function (value) {
			//this.$nextTick(() => { this.select= null })
			this.$emit('return-employee', value)	
			
		},	

		querySelections: _.debounce(function (v) {    
			this.loading = true			
			const apiEsriToken = jscookie.get(AUTH_API_COOKIE)			
			let payload = { 'search': v }
			fetch("https://api.ba.arizona.edu/if/search/employee",			
				{
						headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'apiEsriToken': apiEsriToken						
						},
						method: "POST",
                        body: JSON.stringify(payload)
				})
				.then(response => response.json())
				.then(data => { 
					this.items = data 
					this.loading = false
				})
		}, 500),
	}
}
</script>

<style>
.v-list__tile--highlighted {
	height: 70px;
}

</style>




// WEBPACK FOOTER //
// src/components/forms/EmployeeAutocomplete.vue